module.exports = __webpack_public_path__ + "img/img_038@2x.9342e3a8.png";